export function blockImageContent() {
    window.addEventListener('resize', function () {
        set_masked_logo_desktop()
    })

    set_masked_logo_desktop();
}

function set_masked_logo_desktop() {
    document.querySelectorAll('.image-content-block.is-style-logo-mask').forEach((container) => {
        let mask_container = container.querySelector('div.mask'),
            logo = container.querySelector('.logo_dot'),
            mask_height = mask_container.offsetHeight;

        logo.style.height = mask_height + 'px'
    })
}
